import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import { Grid } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import * as Cred from '../../../../common/creds';
import * as Utils from '../../../../common/utilSvc';
import { isNullOrUndefined, isUndefined } from "util";
import './FeedbackFormComponent.css';

import { GoogleSpreadsheet } from 'google-spreadsheet';


class FeedbackFormComponent extends React.Component {
    
    constructor(props){

        super(props);
        //company, isFeedbackSaved

        this.state = {
            email: null,
            feedback: {
                Further_info_request: {
                    title: "Request more information",
                    description: null,
                    label_desc: 'What info do you need?',
                    isFeedbackSaved: false,
                    eqSheetExcel: 'Further_info_request'
                },
                General_feedback: {
                    title: "Provide feedback",
                    description: null,
                    label_desc: 'Tell us more',
                    isFeedbackSaved: false,
                    eqSheetExcel: 'General_feedback'
                }
            },
            selected: 'Further_info_request'
        }

        //sheet: Further_info_request, General_feedback
        
        this.sendInfoToGoogleSheet = this.sendInfoToGoogleSheet.bind(this);
        this.canShowSaveButton = this.canShowSaveButton.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.save = this.save.bind(this);
        this.reset = this.reset.bind(this);
        this.onClickTab = this.onClickTab.bind(this);

        this.renderEmailField = this.renderEmailField.bind(this);
        this.renderDescriptionField = this.renderDescriptionField.bind(this);
        this.renderTab = this.renderTab.bind(this);

    }

    componentDidMount(){

    }

    async sendInfoToGoogleSheet(feedback_type, feedback_row){

        try{
        let docId = Cred.feedbackGoogleSheetCred.sheetId;

        let doc = new GoogleSpreadsheet(docId);
        // console.log(doc);
       
        if(isNullOrUndefined(doc))
            return;
        await doc.useServiceAccountAuth({
            "private_key": Cred.feedbackGoogleSheetCred.private_key,
            "client_email": Cred.feedbackGoogleSheetCred.client_email,
            });
        
        let feedback_sheet = this.state.feedback[feedback_type].eqSheetExcel;

    //    /*
        await doc.loadInfo();
        const sheet = doc.sheetsByTitle[feedback_sheet]; // or use doc.sheetsById[id] or doc.sheetsByTitle[title]
        // console.log(sheet.title);

        

        await sheet.addRow(feedback_row);

     /*   
     await sheet.addRow({ 
            email: 'flowpro2021@gmail.com', 
            description: 'I need these specific insights right now.', 
            date: Date.now().toString(),
            company: company 
        });
    //   */ 
        }catch(e){

        }
    }

    handleChange(event, type){
        if(type=="email"){
            let email = event.target.value;
            if(!isNullOrUndefined(email)){
                email = email.replace("\n","");
            }
            this.setState({email: email});
        }
        else if(type=="description"){
            let selected = this.state.selected;
            let feedback = this.state.feedback;
            if(selected in feedback){
                feedback[selected].description = event.target.value;
                this.setState({feedback:feedback});                
            }
        }
    }

    renderEmailField(){

        return (
            <div style={{marginTop:'5px', textAlign:'left'}}>
                <form>
                    <label>
                        <TextField 
                            type="text"
                            variant="outlined"
                            multiline
                            label = "Email"
                            placeholder = "Email"
                            value={this.state.email}
                            onChange={(e) => { this.handleChange(e,"email")}}
                            rowsMax="2"
                            rowsMin="1"
                            style={{
                                background: 'white',
                                marginTop:'6px',
                                marginBottom:'6px',
                                width:'95%'
                                }}/>
                    </label>
                </form>
            </div>
        )
    }

    renderDescriptionField(){

        return (
            <div style={{marginTop:'5px', textAlign:'left'}}>
                <form>
                    <label>
                        <TextField 
                            type="text"
                            variant="outlined"
                            multiline
                            label = {this.state.feedback[this.state.selected].label_desc}
                            placeholder = {this.state.feedback[this.state.selected].label_desc}
                            value={this.state.feedback[this.state.selected].description}
                            onChange={(e) => { this.handleChange(e,"description")}}
                            rowsMax="7"
                            rowsMin="4"
                            style={{
                                background: 'white',
                                marginTop:'6px',
                                marginBottom:'6px',
                                width:'95%'
                                }}/>
                    </label>
                </form>
            </div>
        )
    }

    canShowSaveButton(){
        if(this.state.selected == 'Further_info_request' || this.state.selected == 'General_feedback'){
            if(isNullOrUndefined(this.state.email) || this.state.email.trim().length==0)
                return false;
            if(isNullOrUndefined(this.state.feedback[this.state.selected].description) || 
            this.state.feedback[this.state.selected].description.trim().length==0)
                return false;
            if(this.state.feedback[this.state.selected].isFeedbackSaved)
                return false;
            return true;
        }
        return false;
    }

    async save(){
        let selected = this.state.selected;
        //Further_info_request, General_feedback

        let company = null;
        if(!isNullOrUndefined(this.props.company))
            company = this.props.company;

        if(selected == 'Further_info_request'){
            let row = {
                email: this.state.email, 
                description: this.state.feedback[selected].description, 
                date: Utils.formatDate(Date.now()),
                company: company
            }
            this.sendInfoToGoogleSheet(selected,row);
        }
        else if(selected == 'General_feedback'){
            let row = {
                email: this.state.email, 
                description: this.state.feedback[selected].description, 
                date: Utils.formatDate(Date.now())
            }
            this.sendInfoToGoogleSheet(selected,row);
        }

        let feedback = this.state.feedback;
        feedback[selected].isFeedbackSaved = true;
        feedback[selected].description = null;
        this.setState({
            feedback: feedback
        });
    }

    reset(){
        let selected = this.state.selected;
        let feedback = this.state.feedback;
        feedback[selected].isFeedbackSaved = false;
        this.setState({
            feedback: feedback
        });
    }

    onClickTab(tab){
        if(!isNullOrUndefined(tab)){
            this.setState({
                selected: tab
            });
        }
    }

    renderTab(tab){
        let desc = this.state.feedback[tab].title;
        let isActive = false;
        if(tab == this.state.selected)
            isActive = true;
        let scope = this;
        return (
            <Grid item lg={4} sm={6} xs={12}>
                <Paper elevation={0} square variant="outlined" 
                className={"feedbackTabContainer feedbackTabContainerSelected-"+ String(isActive)}
                onClick = {() => scope.onClickTab(tab)}>
                    {desc}
                </Paper>
            </Grid>
        )
    }

    render(){

        let renderTabs = null;
        let feedback = this.state.feedback;
        let scope = this;
        renderTabs = Object.keys(feedback).map((key, index) => {
            return scope.renderTab(key)
        })

        return (
            <div className="feedbackFormContainer">
                <h2> Get in touch</h2>
                <Grid container spacing={1} style={{marginBottom:'1em'}}>
                    {renderTabs}
                </Grid>
                <div style={{marginBottom:'10px'}}></div>

                {this.state.feedback[this.state.selected].isFeedbackSaved?
                    <div>
                        Your response has been saved!
                    </div>
                    :
                    <div>
                        {this.renderEmailField()}
                        {this.renderDescriptionField()}
                    </div>
                }
                <div style={{textAlign:'left', marginTop:'10px', display:'flex', flexWrap: 'wrap'}}>
                    {this.canShowSaveButton()?
                        <div style={{marginRight:'1em'}}>
                            <Button 
                            color="primary"
                            variant="contained"
                            className="genericButton_v1" 
                            onClick = {this.save}
                            >
                            Submit
                            </Button>
                        </div>
                        :
                        null
                    }
                    {this.state.feedback[this.state.selected].isFeedbackSaved?
                        <div style={{marginRight:'1em'}}>
                            <Button 
                            color="primary"
                            variant="contained"
                            className="genericButton_v1" 
                            onClick = {this.reset}
                            >
                            Go back
                            </Button>
                        </div>
                        :
                        null
                    }

                </div>

            </div>
        )
    }
}
export default FeedbackFormComponent;
